export const getBannerNameFromImageUrl = (imageUrl = '') => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return '';
  }

  const pathWithoutQueryOrHash = imageUrl.split(/[?#]/)[0];
  const encodedFileName = pathWithoutQueryOrHash.split('/').pop();

  if (!encodedFileName) {
    return '';
  }

  let fileName = encodedFileName;

  try {
    fileName = decodeURIComponent(encodedFileName);
  } catch (error) {
    // Keep the undecoded filename when the URL contains malformed encoding.
  }

  return fileName.replace(/\.[^./]+$/, '');
};

export const getBannerTracking = ({
  bannerImgUrl,
  isCarousel = false,
  position,
  bannerLocation,
  linkName,
}) => ({
  bannerName: getBannerNameFromImageUrl(bannerImgUrl),
  bannerCategory: isCarousel ? 'carousel' : 'static-banner',
  bannerLocation: isCarousel && Number.isFinite(position)
    ? `${bannerLocation}-pos-${position}`
    : bannerLocation,
  linkName,
});
